import { render, staticRenderFns } from "./LandingPageTemplate.vue?vue&type=template&id=f33e618e"
import script from "./LandingPageTemplate.vue?vue&type=script&lang=js"
export * from "./LandingPageTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports